// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__2220H","section--dark":"section_section--dark__3tenD"};